import React from "react";
import { Link } from "react-router-dom";
import Modal from "../../../common/Modal/Modal";

export default function RegForm(props) {
    return (
        <Modal slogan={true} className="login" >
            {props.inviteCompanyName &&
                <p className="content2 light-black text-center gap-below-m">You've been invited to join <span className="heavy">{props.inviteCompanyName}</span></p>
            }
            <form className="form" onSubmit={(e) => props.onSubmit(e)} >
                <div className="inputs-wrapper gap-below-s" >
                    <div className="input-basic addspace" > 
                        <input
                            type="text"
                            name="first_name"
                            onChange={(e) => props.onChange(e)}
                            id="first_name"
                            value={props.newUser.first_name}
                            required
                        />
                        <label htmlFor="first_name" >First Name <span>*</span></label>
                    </div> 
                    <div className="input-basic addspace" > 
                        <input
                            type="text"
                            name="last_name"
                            onChange={(e) => props.onChange(e)}
                            id="last_name"
                            value={props.newUser.last_name}
                            required
                        />
                        <label htmlFor="last_name" >Last Name <span>*</span></label>
                    </div>
                    <div className="input-basic addspace" > 
                        <input
                            type="email"
                            name="email"
                            onChange={(e) => props.onChange(e)}
                            id="email"
                            value={props.newUser.email}
                            required
                            disabled={!!props.inviteCompanyName}
                        />
                        <label htmlFor="email" >Work Email <span>*</span></label>
                    </div>
                    <div className="input-basic addspace" > 
                        <input
                            type="tel"
                            name="phone"
                            onChange={(e) => props.onChange(e)}
                            id="phone"
                            value={props.newUser.phone}
                        />
                        <label htmlFor="phone" >Phone Number</label>
                    </div>
                    <div className="input-basic addspace" >				
                        <input
                            type="password"
                            name="password"
                            onChange={(e) => props.onChange(e)}	
                            id="password"
                            value={props.newUser.password}
                            required
                        />
                        <label htmlFor="password" >Password <span>*</span></label>
                    </div>
                    <div className="input-basic addspace" >				
                        <input
                            type="password"
                            name="passwordconfirm"
                            onChange={(e) => props.onChange(e)}	
                            id="passwordconfirm"
                            value={props.newUser.passwordconfirm}
                            // required
                        />
                        <label htmlFor="passwordconfirm" >Confirm password <span>*</span></label>
                    </div>
                </div>
                <button type="submit" id="register" className="btn pri gap-below-s gap-above-s" disabled={props.isSubmitting} >{props.isSubmitting ? "SIGNING UP..." : "SIGN UP"}</button>
            </form>
            <Link style={{width: "100%"}}  id="register" className="btn sec gap-below-s" to="login" >LOGIN</Link>
        </Modal>
    )
}
